export default __webpack_public_path__ + "static/media/WheelMaintenance3.82127ff3.png";